import {prepareRequest} from "@/services"
import {setParamsToURL} from "@/services";
import {TARGET_API_URL_LIST} from "@/services/routes/target/target";
import store from "../../../../src/state/store"


async function getListSalespersonTarget(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_SALESPERSON_LIST, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getSingleSalespersonTarget(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_SALESPERSON_GET_SINGLE, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}
async function addSalespersonTarget(params,body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_SALESPERSON_ADD,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function updateSalespersonTarget(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_SALESPERSON_UPDATE,params),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function deleteSalespersonTarget(params,body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_SALESPERSON_DELETE,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}


async function getListCurrentTarget(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_CURRENT_LIST, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getSingleCurrentTarget(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_CURRENT_GET_SINGLE, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}
async function addCurrentTarget(params,body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_CURRENT_ADD,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function updateCurrentTarget(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_CURRENT_UPDATE,params),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function deleteCurrentTarget(params,body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(TARGET_API_URL_LIST.TARGET_CURRENT_DELETE,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}


export {getListSalespersonTarget,getSingleSalespersonTarget,addSalespersonTarget,updateSalespersonTarget, deleteSalespersonTarget, getListCurrentTarget,getSingleCurrentTarget,addCurrentTarget,updateCurrentTarget,deleteCurrentTarget}